// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__PKI0H","rootCenter":"LoadMoreObserver_rootCenter__2fASh","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2Ry8z"};